import _ from "lodash";

let regionFilters = null;

let accountManagerFilters = null;

let cachedRegionElement = null;

let cachedAccountManagerElement = null;

const refreshFilters = () => {
  const regions = document.getElementById("region");
  const accountManagers = document.getElementById("account_manager");

  if (regions !== cachedRegionElement) {
    cachedRegionElement = regions;
    regionFilters = regions?.dataset.payerFilters ? JSON.parse(regions.dataset.payerFilters) : null;
  }

  if (accountManagers !== cachedAccountManagerElement) {
    cachedAccountManagerElement = accountManagers;
    accountManagerFilters = accountManagers?.dataset.payerFilters
      ? JSON.parse(accountManagers.dataset.payerFilters)
      : null;
  }
};

const parsePayerId = datum => {
  if (typeof datum === "number") {
    return datum;
  } else {
    return datum.payer;
  }
};

const comparePairToId = (pair, id) => parsePayerId(pair) === id;

export default (payerType, payerPairs) => {
  refreshFilters();

  const currentRegion = document.getElementById("region")?.value;
  const currentAccountManager = document.getElementById("account_manager")?.value;

  if (!currentRegion && !currentAccountManager) {
    return payerPairs;
  }

  let filteredPayerPairs = [...payerPairs];

  if (currentRegion && regionFilters?.[currentRegion]) {
    filteredPayerPairs = _.intersectionWith(
      filteredPayerPairs,
      regionFilters[currentRegion][payerType],
      comparePairToId,
    );
  }

  if (currentAccountManager === "unassigned" && accountManagerFilters) {
    const allAccountManagers = _.mapValues(accountManagerFilters, am => am?.[payerType]);
    const idsFromAllAccountManagers = _.flatten(_.values(allAccountManagers)).filter(Boolean);

    filteredPayerPairs = _.differenceWith(
      filteredPayerPairs,
      idsFromAllAccountManagers,
      comparePairToId,
    );
  } else if (currentAccountManager && accountManagerFilters?.[currentAccountManager]) {
    filteredPayerPairs = _.intersectionWith(
      filteredPayerPairs,
      accountManagerFilters[currentAccountManager][payerType],
      comparePairToId,
    );
  }

  return filteredPayerPairs;
};
